import { Record } from 'immutable'

export interface IEntityPermissions {
  readonly canDelete: boolean
  readonly canEdit: boolean
}

const EntityPermissionsRecord = Record({
  canDelete: false,
  canEdit: false,
})

export class EntityPermissions extends EntityPermissionsRecord
  implements IEntityPermissions {
  public static fromJS(initialState?: Partial<IEntityPermissions>) {
    return new EntityPermissions(initialState)
  }

  public readonly canDelete: boolean
  public readonly canEdit: boolean

  constructor(props?: Partial<EntityPermissions>) {
    props ? super(props) : super()
  }
}
